import { MergeFormSection } from "components/MainSectionTemplate/types";
import BirthdateRow from "contact/detail/components/BirthdateRow";
import { getMaritalStatus } from "contact/detail/components/MaritalStatusRow";
import { ContactFormState } from "contact/models";
import React from "react";
import { newLineToBr } from "utilities";
import { isNullOrEmptyString } from "shared/utils";

export const otherDetailSection = (
  existingContact: ContactFormState,
  sourceContact: ContactFormState,
  currentContact: ContactFormState,
  setCurrentContact: (contact: ContactFormState) => void
): MergeFormSection => ({
  key: "otherDetails",
  title: RESX.Company.OtherDetails,
  fields: [{
    key: "socialSecurity",
    label: RESX.Contact.SocialSecurity,
    currentValue: currentContact.socialSecurity,
    existingValue: existingContact.socialSecurity,
    sourceValue: sourceContact.socialSecurity,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <div>{value}</div>,
    onSourceClick: () => setCurrentContact({ ...currentContact, socialSecurity: sourceContact.socialSecurity }),
    onExistingClick: () => setCurrentContact({ ...currentContact, socialSecurity: existingContact.socialSecurity }),
  }, {
    key: "birthdate",
    label: RESX.Contact.DateOfBirth,
    currentValue: currentContact.birthdate,
    existingValue: existingContact.birthdate,
    sourceValue: sourceContact.birthdate,
    isEmpty: (value) => !value,
    render: (value) => <BirthdateRow birthdate={value} />,
    onSourceClick: () => setCurrentContact({ ...currentContact, birthdate: sourceContact.birthdate }),
    onExistingClick: () => setCurrentContact({ ...currentContact, birthdate: existingContact.birthdate }),
  }, {
    key: "birthplace",
    label: RESX.Contact.PlaceOfBirth,
    currentValue: currentContact.birthplace,
    existingValue: existingContact.birthplace,
    sourceValue: sourceContact.birthplace,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <div>{value}</div>,
    onSourceClick: () => setCurrentContact({ ...currentContact, birthplace: sourceContact.birthplace }),
    onExistingClick: () => setCurrentContact({ ...currentContact, birthplace: existingContact.birthplace }),
  }, {
    key: "maritalStatus",
    label: RESX.Contact.MaritalStatus,
    currentValue: currentContact.maritalStatus,
    existingValue: existingContact.maritalStatus,
    sourceValue: sourceContact.maritalStatus,
    isEmpty: (value: server.dto.MaritalStatuses) => !value || value === "unknown",
    render: (value) => <span>{getMaritalStatus(value)}</span>,
    onSourceClick: () => setCurrentContact({ ...currentContact, maritalStatus: sourceContact.maritalStatus }),
    onExistingClick: () => setCurrentContact({ ...currentContact, maritalStatus: existingContact.maritalStatus }),
  }, {
    key: "additionalInformation",
    label: RESX.Company.AdditionalInformation,
    currentValue: currentContact.additionalInformation,
    existingValue: existingContact.additionalInformation,
    sourceValue: sourceContact.additionalInformation,
    isEmpty: (value) => isNullOrEmptyString(value),
    render: (value) => <div>{newLineToBr(value)}</div>,
    onSourceClick: () => setCurrentContact({ ...currentContact, additionalInformation: sourceContact.additionalInformation }),
    onExistingClick: () => setCurrentContact({ ...currentContact, additionalInformation: existingContact.additionalInformation }),
  }]
})